import { useState } from "react";
import * as T1 from "./typeOne.styles";
import Accordion from "../../../common/accordion/accordion";
import { InfoRow } from "../GroupEvent.styles";
import CustomFileInput from "../../../common/CustomFileInput";
import FloatingInput from "../../../common/input/floatingInput";
import { useEffect } from "react";
import { useRef } from "react";

const TypeOne = (props) => {
  const {
    inputData,
    setInputData,
    handleInputData,
    detailData,
    cancelInsert,
    onClickHandleModal,
    typeOneUseForm,
    stickyBodyRef,
  } = props;
  const fileRef = useRef(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    watch,
  } = typeOneUseForm;
  const [activeTab, setActiveTab] = useState([]);

  const accordionData = [
    {
      title: "주문 수량",
      content: (
        <>
          <FloatingInput
            placeholder="주문 수량"
            type="number"
            name="cnt"
            register={(name) => {
              return {
                ...register(name, {
                  value: inputData?.[name],
                  onChange: (e) => handleInputData(e, name),
                }),
              };
            }}
            value={inputData?.cnt || ""}
            error={errors?.cnt}
            min={500}
          />
        </>
      ),
    },
    {
      title: "주문자 정보",
      content: (
        <>
          <FloatingInput
            placeholder="업체명"
            name="company"
            register={(name) => {
              return {
                ...register(name, {
                  value: inputData?.[name],
                  onChange: (e) => handleInputData(e, name),
                }),
              };
            }}
            value={inputData?.company || ""}
            error={errors?.company}
          />
          <FloatingInput
            placeholder="담당자"
            name="name"
            register={(name) => {
              return {
                ...register(name, {
                  value: inputData?.[name],
                  onChange: (e) => handleInputData(e, name),
                }),
              };
            }}
            value={inputData?.name || ""}
            error={errors?.name}
          />
          <FloatingInput
            placeholder="담당자 연락처"
            name="phone"
            register={(name) => {
              return {
                ...register(name, {
                  value: inputData?.[name],
                  onChange: (e) => handleInputData(e, name),
                }),
              };
            }}
            value={inputData?.phone || ""}
            error={errors?.phone}
          />
          <FloatingInput
            placeholder="담당자 이메일"
            name="email"
            register={(name) => {
              return {
                ...register(name, {
                  value: inputData?.[name],
                  onChange: (e) => handleInputData(e, name),
                }),
              };
            }}
            value={inputData?.email || ""}
            error={errors?.email}
          />
        </>
      ),
    },
    {
      title: "배송지 정보",
      content: (
        <>
          <div className="form-group mb-0">
            <FloatingInput
              placeholder="주소"
              name="doro_addr"
              register={(name) => {
                return {
                  ...register(name, {
                    value: inputData?.[name],
                    onChange: (e) => handleInputData(e, name),
                  }),
                };
              }}
              value={inputData?.doro_addr || inputData?.base_addr || ""}
              readOnly
              onClick={onClickHandleModal}
              error={errors?.doro_addr}
            />
            <FloatingInput
              placeholder="상세 주소"
              name="detail_addr"
              value={inputData?.detail_addr || ""}
              register={(name) => {
                return {
                  ...register(name, {
                    value: inputData?.[name],
                    onChange: (e) => handleInputData(e, name),
                  }),
                };
              }}
              error={errors?.detail_addr}
            />
          </div>
        </>
      ),
    },
    {
      title: "추가 정보",
      content: (
        <>
          <div className="form-group mb-0">
            <div className="d-flex flex-column">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <h6 className="">파일 업로드</h6>
                {detailData?.file && (
                  <a
                    role="button"
                    className="btn btn-xs"
                    target="__blank"
                    href={detailData.file}
                  >
                    칼선 다운로드
                  </a>
                )}
              </div>
              <div ref={fileRef}>
                <CustomFileInput
                  handleFiles={(files) => {
                    setInputData({ ...inputData, file: files[0] });
                  }}
                  reset={(files) => reset({ ...getValues(), file: files[0] })}
                  error={errors?.file}
                  name={"files"}
                  max={1}
                />
              </div>
              {errors?.file && (
                <span className="mt-1 text-danger">{errors?.file.message}</span>
              )}
              <span className="mt-3">
                * 로고파일 또는 로고가 배치된 칼선도안을 업로드해주세요 (ai
                파일)
              </span>
              <span>
                * 로고가 준비되어 있지 않은 경우에는 관련 이미지를
                업로드해주세요 (파일 형식 무관)
              </span>
            </div>
            <div className="mt-3 d-flex flex-column">
              <h6 className="mb-3">디자인 작업 선택</h6>
              <select
                className={`form-select ${
                  errors.editYn && "border-danger shadow-none"
                }`}
                name="editYn"
                value={inputData?.editYn || ""}
                {...register("editYn", {
                  value: inputData?.editYn,
                  onChange: (e) => handleInputData(e, "editYn"),
                })}
              >
                <option value={""} disabled>
                  디자인 작업 선택
                </option>
                <option value={"TYPE0"}>선택 안함</option>
                <option value={"TYPE1"}>도안 칼선배치</option>
                <option value={"TYPE2"}>디자인 서비스(별도 비용 상담)</option>
              </select>
              {errors?.editYn && (
                <span className="mt-1 text-danger">
                  {errors?.editYn.message}
                </span>
              )}
              <span className="mt-3">
                * 로고파일이 있지만 일러스트 작업이 어려우신 칼선도안 배치를
                선택해주세요.
              </span>
              <span>
                * 로고파일이 없는 경우{" "}
                <a href="/customizing/design-service/" target="__blank">
                  디자인 서비스
                </a>
                를 선택해주세요.
              </span>
              <textarea
                placeholder="요청사항"
                className="mt-3"
                name="memo"
                value={inputData?.memo || ""}
                {...register("memo", {
                  value: inputData?.memo,
                  onChange: (e) => handleInputData(e, "memo"),
                })}
              />
            </div>
          </div>
        </>
      ),
    },
  ];

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      const tempArr = new Array(accordionData.length).fill(true);
      setActiveTab(tempArr);

      if (Object.keys(errors).length === 1 && errors.file) {
        stickyBodyRef.current.scrollTo({
          behavior: "instant",
          left: 0,
          top: fileRef.current.offsetTop - 130,
        });
      }
    }
  }, [errors]);

  return (
    <>
      <T1.TypeOneSection>
        {accordionData?.length > 0 &&
          accordionData.map((el, i) => (
            <Accordion data={el} open={activeTab[i]} key={i} />
          ))}
      </T1.TypeOneSection>
    </>
  );
};
export default TypeOne;
